import { render, staticRenderFns } from "./EventTypeSelect.vue?vue&type=template&id=904b1fb8&scoped=true&"
import script from "./EventTypeSelect.vue?vue&type=script&lang=js&"
export * from "./EventTypeSelect.vue?vue&type=script&lang=js&"
import style0 from "./EventTypeSelect.vue?vue&type=style&index=0&id=904b1fb8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "904b1fb8",
  null
  
)

export default component.exports